import React from 'react';
import PropTypes from 'prop-types';
import distance from '@turf/distance';
import circle from '@turf/circle';
import center from '@turf/center';
import bbox from '@turf/bbox';
import area from '@turf/area';
import bboxPolygon from '@turf/bbox-polygon'
import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';


import { strings } from 'APP_ROOT/localization';

export default class GeofenceType extends React.Component {

    static propTypes = {
        value: PropTypes.string.isRequired,
    }

    state = {
        confirmRemoveOpen: false,
        selectedType: this.props.value
    }

    openConfirmRemoveDialog = newType => {
        
        this.setState({
            confirmRemoveOpen: true,
            selectedType: newType
        });
    }

    closeConfirmRemoveDialog = () => this.setState({ confirmRemoveOpen: false });

    changeType = () => {
        this.closeConfirmRemoveDialog();
        this.state.selectedType === "Point" ? this.switchToCircle() : this.switchToPolygon();
    }

    switchToCircle = () => {
        const { geofenceId, editingGeometry } = this.props;
        if(geofenceId && editingGeometry.geometry.type === "Polygon" && editingGeometry.geometry.coordinates){
            const [radius, center] = this.convertToCircle(editingGeometry);

            const newGeojson = {...editingGeometry};

            newGeojson.geometry = {type: "Point", coordinates: center};
            newGeojson.properties = {radius: radius, area: undefined};

            return this.props.onConvert(newGeojson);
        }

        this.props.onChange("Point");
    }

    switchToPolygon = () => {
        const { geofenceId, editingGeometry } = this.props;
        if(geofenceId && editingGeometry.geometry.type === "Point"){
            const [area, coordinates] = this.convertToSquare(editingGeometry);

            const newGeojson = {...editingGeometry};

            newGeojson.geometry = {type: "Polygon", coordinates};
            newGeojson.properties = {area : area, radius: undefined};

            return this.props.onConvert(newGeojson);
        }

        this.props.onChange("Polygon");
    }

    convertToCircle = (editingGeometry) => {
        const polygonGeometry = editingGeometry.geometry;

        // a bounding box is a rectangle that surrounds a polygon
        // we need to calculate the bounding box of the polygon in case polygon shape is not a rectangle
        // then use the bounding box to calculate the circle that has the same area as the polygon
        const polygonBoundingBox = bbox(polygonGeometry);
        const boundingBoxRectangle = bboxPolygon(polygonBoundingBox);

        const startPoint = boundingBoxRectangle.geometry.coordinates[0][0];
        const secondPoint = boundingBoxRectangle.geometry.coordinates[0][1];
        const thirdPoint = boundingBoxRectangle.geometry.coordinates[0][2];
      
        // calculate the length of the sides of the bounding box rectangle
        const sideOneLength = distance(startPoint, secondPoint); // in km
        const sideTwoLength = distance(secondPoint, thirdPoint); // in km

        const biggerSide = Math.max(sideOneLength, sideTwoLength);

        const circleRadius = biggerSide / 2; // in km
        const circleCenter = center(boundingBoxRectangle);

        return [Math.round(circleRadius * 1000), circleCenter.geometry.coordinates];
    }

    convertToSquare = (editingGeometry) => {
        const circleGeometry = editingGeometry.geometry;

        const circleCenter = circleGeometry.coordinates;
        const circleRadius = editingGeometry.properties.radius / 1000; // in meters

        // create a polygon that represents the circle (not exactly a circle but very close to it)
        const circlePolygon = circle(circleCenter, circleRadius);

        // calculate the bounding box of the circle polygon
        const circlePolygonBoundingBox = bbox(circlePolygon.geometry);
        const boundingBoxRectangle = bboxPolygon(circlePolygonBoundingBox);
        const boundingBoxRectangleArea = area(boundingBoxRectangle);

        return [boundingBoxRectangleArea, boundingBoxRectangle.geometry.coordinates];
    }

    render () {
        const [currentType, inEditMode] = this.props.editingGeometry ? [this.props.editingGeometry.geometry.type, true] : [this.props.value, false];
        return (
            <section className="type">
                <h4 className="label">{strings.resource_type}</h4>
                <div className="value">
                    {inEditMode ? 
                    <>
                        <button onClick={()  => this.props.geofenceId ? this.openConfirmRemoveDialog("Point") : this.switchToCircle()}>
                            {currentType && currentType === "Point" ?
                                <i className="material-icons">radio_button_checked</i> :
                                <i className="material-icons">radio_button_unchecked</i>
                            }
                            <span>{strings.resource_type_circle}</span>
                        </button>
                    
                        <button onClick={() => this.props.geofenceId ? this.openConfirmRemoveDialog("Polygon") : this.switchToPolygon()}>
                            {currentType && currentType === "Polygon" ?
                                <i className="material-icons">radio_button_checked</i> :
                                <i className="material-icons">radio_button_unchecked</i>
                            }
                            <span>{strings.resource_type_polygon}</span>
                        </button>

                        <ConfirmDialog
                            isOpen={this.state.confirmRemoveOpen}
                            title={this.props.value === "Point" ? strings.geofence_change_type_polygon_prompt : strings.geofence_change_type_circle_prompt}
                            onOk={this.changeType}
                            onCancel={this.closeConfirmRemoveDialog}
                            onDismiss={this.closeConfirmRemoveDialog}
                        />
                    </>
                    : <span>{currentType === "Point" ? strings.resource_type_circle : strings.resource_type_polygon}</span>
                    }
                </div>
            </section>
        )
    }
}